__turbopack_context__.v({
  "cardContent": "feature-selector-module-scss-module__Z_B0fW__cardContent",
  "cardContentWrapper": "feature-selector-module-scss-module__Z_B0fW__cardContentWrapper",
  "cardDescription": "feature-selector-module-scss-module__Z_B0fW__cardDescription",
  "cardTitle": "feature-selector-module-scss-module__Z_B0fW__cardTitle",
  "desktopContent": "feature-selector-module-scss-module__Z_B0fW__desktopContent",
  "featureCard": "feature-selector-module-scss-module__Z_B0fW__featureCard",
  "featureContainer": "feature-selector-module-scss-module__Z_B0fW__featureContainer",
  "featureImage": "feature-selector-module-scss-module__Z_B0fW__featureImage",
  "featureOptionsContainer": "feature-selector-module-scss-module__Z_B0fW__featureOptionsContainer",
  "mobileContent": "feature-selector-module-scss-module__Z_B0fW__mobileContent",
  "mobileDescription": "feature-selector-module-scss-module__Z_B0fW__mobileDescription",
  "mobileScrollContainer": "feature-selector-module-scss-module__Z_B0fW__mobileScrollContainer",
  "mobileSlide": "feature-selector-module-scss-module__Z_B0fW__mobileSlide",
  "mobileTitle": "feature-selector-module-scss-module__Z_B0fW__mobileTitle",
  "paginationContainer": "feature-selector-module-scss-module__Z_B0fW__paginationContainer",
  "paginationPill": "feature-selector-module-scss-module__Z_B0fW__paginationPill",
  "paginationPillActive": "feature-selector-module-scss-module__Z_B0fW__paginationPillActive",
  "scrollButton": "feature-selector-module-scss-module__Z_B0fW__scrollButton",
  "scrollButtonContainer": "feature-selector-module-scss-module__Z_B0fW__scrollButtonContainer",
});
